<div class="ant-comment-inner">
  <div class="ant-comment-avatar">
    <ng-content select="nz-avatar[nz-comment-avatar]"></ng-content>
  </div>
  <div class="ant-comment-content">
    <div class="ant-comment-content-author">
      <span *ngIf="nzAuthor" class="ant-comment-content-author-name">
        <ng-container *nzStringTemplateOutlet="nzAuthor">{{ nzAuthor }}</ng-container>
      </span>
      <span *ngIf="nzDatetime" class="ant-comment-content-author-time">
        <ng-container *nzStringTemplateOutlet="nzDatetime">{{ nzDatetime }}</ng-container>
      </span>
    </div>
    <ng-content select="nz-comment-content"></ng-content>
    <ul class="ant-comment-actions" *ngIf="actions?.length">
      <li *ngFor="let action of actions">
        <span><ng-template [nzCommentActionHost]="action.content"></ng-template></span>
      </li>
    </ul>
  </div>
</div>
<div class="ant-comment-nested">
  <ng-content></ng-content>
</div>